import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=53a465a6&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=js"
export * from "./ArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=53a465a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a465a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53a465a6')) {
      api.createRecord('53a465a6', component.options)
    } else {
      api.reload('53a465a6', component.options)
    }
    module.hot.accept("./ArticleDetail.vue?vue&type=template&id=53a465a6&scoped=true", function () {
      api.rerender('53a465a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/components/ArticleDetail.vue"
export default component.exports